import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Card from "components/card";
import MessageCard from "./MessageCard";
import SearchBar from "components/search/SearchBar";
import MessageCardDetails from "./MessageCardDetails";
import { getTicketDetails } from "../../../../../../redux/ticket/ticketState";

const MessagePanelList = ({ filteredMessages = [], getStatusDisplay }) => {
    const dispatch = useDispatch();
    const [searchKeyword, setSearchKeyword] = useState("");
    const [selectedMessage, setSelectedMessage] = useState(filteredMessages[0]);

    const ticketDetails = useSelector(state => state.ticket.ticketDetails?.data);

    const handleSearch = ({ keyword }) => {
        setSearchKeyword(keyword.toLowerCase());
    };

    const handleSelectMessage = (message) => {
        setSelectedMessage(message);
        if (message?.tic_id) {
            dispatch(getTicketDetails({ tic_id: message.tic_id }));
        }
    };

    const displayMessage = (ticketDetails && ticketDetails.tic_id === selectedMessage?.tic_id) 
        ? ticketDetails 
        : selectedMessage;

    const filtered = filteredMessages.filter(msg =>
        msg.tic_title?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        msg.department?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        msg.tic_description?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        msg.tic_message?.toLowerCase().includes(searchKeyword.toLowerCase())
    );

    return (
        <>
            <Card className="flex flex-col gap-6 rounded-xl text-slate-900 border-2 border-slate-200 shadow-lg lg:col-span-1 overflow-hidden lg:block">
                <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 [.border-b]:pb-6 bg-gradient-to-br from-emerald-50 to-green-50 border-b p-3 sm:p-4 dark:from-emerald-900 dark:to-white/10">
                    <h4 className="text-[16px] sm:text-[18px] title-text">My Messages</h4>
                    <p className="text-slate-700 text-[12px] sm:text-[14px] muted-text">
                        {filtered.length} message{filtered.length !== 1 ? "s" : ""}
                    </p>
                </div>
                <div className="pb-6 p-3 sm:p-4 space-y-3">
                    <SearchBar
                        placeholder="Search messages..."
                        searchHandler={handleSearch}
                        onChange={(e) => handleSearch(e.target.value)} 
                    />
                    <div className="bg-slate-200 shrink-0 h-px w-full"></div>
                    <div className="relative h-[400px] sm:h-[500px] lg:h-[600px] overflow-hidden">
                        <div className="h-full overflow-y-auto overscroll-contain scrollbar-hide">
                            <div className="space-y-2">
                                {filtered.map((message, i) => (
                                    <MessageCard 
                                        key={message.tic_id || i} 
                                        recordata={message}
                                        selected={selectedMessage?.tic_id === message.tic_id}
                                        onClick={() => handleSelectMessage(message)}
                                        getStatusDisplay={getStatusDisplay}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Card>

            {displayMessage && (
                <MessageCardDetails 
                    recordata={displayMessage}
                    getStatusDisplay={getStatusDisplay}
                />
            )}                 
        </>
    );
};

export default MessagePanelList;